import React from 'react';
import Typography from './Typography';

const OverviewList = ({ title, value, children, icon, borderLeft = false, borderTop = false, borderBottom = false }) => {
    return (
        <div className={`flex py-2 items-center w-full h-full ${borderTop ? 'border-t border-[#151515]' : ''
            } ${borderBottom ? 'border-b border-[#151515]' : ''}`}>
            {borderLeft && <div className='w-[3px] h-[24px] bg-[#DF0F11]'></div>}
            <div className='flex justify-between w-full items-center'>
                {title && <Typography color={'#FFF'} className='ml-[7px]' size={'14px'} family={'Supply'} weight={400} text={title} transform={'uppercase'} />}
                {value && <Typography color={'#FFF'} className='' text={value} size={'14px'} family={'Supply'} weight={400} transform={'uppercase'} />}
            </div>
        </div>
    );
};

export default OverviewList;